import React from "react";
import { useRejectBayHireRequest } from "@features/bay-hire/hooks/useBayHireMutations";
import { useTranslation } from "react-i18next";
import ReasonDialog from "./ReasonDialog";

interface RejectDialogProps {
  open: boolean;
  requestId: string;
  onClose: () => void;
  onSuccess: () => void | Promise<void>;
}

const RejectDialog: React.FC<RejectDialogProps> = ({ open, requestId, onClose, onSuccess }) => {
  const { t } = useTranslation();
  const rejectMutation = useRejectBayHireRequest();

  // DFT-0044 slice F (F3): attachmentId is optional evidence, uploaded and referenced by
  // ReasonDialog - never required to reject.
  const handleSubmit = async (reason: string, attachmentId?: string) => {
    await rejectMutation.mutateAsync({ id: requestId, request: { reason, attachmentId } });
    await onSuccess();
  };

  return (
    <ReasonDialog
      open={open}
      title={t("bay-hire.reject-dialog-title")}
      reasonLabel={t("bay-hire.reject-reason-label")}
      submitLabel={t("bay-hire.reject")}
      testIdPrefix="reject"
      requestId={requestId}
      showAttachmentUpload
      onClose={onClose}
      onSubmit={handleSubmit}
    />
  );
};

export default RejectDialog;
